import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'username',
    fieldName: '用户名',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '姓名',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'phone',
    fieldName: '手机号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'dataAuthority',
    fieldName: '数据权限',
    width: 100
  }, {
    fieldKey: 'depts',
    fieldName: '所属部门',
    convert: context => {
      const { rowData } = context
      const { depts } = rowData
      return depts ? depts.join(',') : ''
    }
  }, {
    fieldKey: 'roles',
    fieldName: '所属岗位',
    convert: context => {
      const { rowData } = context
      const { roles } = rowData
      return roles ? roles.join(',') : ''
    }
  }, {
    fieldKey: 'active',
    fieldName: '激活',
    width: 70,
    convert: context => {
      const { rowData } = context
      const { active } = rowData
      return active ? '激活' : '未激活'
    }
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'idCard',
    fieldName: '身份证',
    width: 160
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'sex',
    fieldName: '性别',
    width: 60
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'email',
    fieldName: '邮箱'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createUsername',
    fieldName: '创建人',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createTime',
    fieldName: '创建时间'
  }
]
